import { FC, ReactNode } from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { twMergeExt } from '@/shared/utils/twMergeExt';

interface Props extends VariantProps<typeof cvaWrapper> {
  className?: string;
  children?: ReactNode;
}

const Skeleton: FC<Props> = ({ className, rounded, children }) => {
  return (
    <div className={twMergeExt(cvaRoot(), className)}>
      <div className={twMergeExt(cvaWrapper({ rounded }))}>{children}</div>
    </div>
  );
};

const cvaRoot = cva([
  'Skeleton-cvaRoot',
  'relative',
  'inline-block',
  'overflow-hidden',
  'after:w-full after:h-full after:absolute after:animate-skeleton after:top-0 after:left-0 after:bg-skeleton',
]);

const cvaWrapper = cva(['Skeleton-cvaWrapper', 'overflow-hidden w-full h-full'], {
  variants: {
    rounded: {
      circle: 'rounded-[50%] ',
    },
  },
});

export default Skeleton;
